import {VueConstructor} from "vue";
import ImagePickerEditor from "@/editors/image-picker.editor.vue";
import Select2 from "@/editors/select2.editor.vue";
import DateEditor from "@/editors/date-picker.editor.vue";

class EditorsPlugin {
    install(vue: VueConstructor) {
        vue.component('image-picker', ImagePickerEditor);
        vue.component('merch-select2', Select2);
        vue.component('date-picker', DateEditor);
    }
}

export default new EditorsPlugin();